<div class="form-group row mb-0">
  <label for="dropdownMenuButton" [ngClass]="'col-sm-' + labelCols"
    class="col-form-label label-admin text-end noselect pe-0">{{label}}</label>
  <div [ngClass]="'col-sm-' + (12-labelCols)" class="my-auto">
    <button [class]="'btn btn-'+buttonColor+' btn-sm'" type="button" (click)="clickAction.emit($event)" [attr.disabled]="disabled ? '' : null">
      <ng-content></ng-content>
    </button><ng-content select="[afterButton]"></ng-content>
  </div>
</div>

<app-admin-divider [dividerKind]="dividerKind"></app-admin-divider>